import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaSearchPlus,
  FaSearchMinus,
  FaRedo,
  FaExternalLinkAlt,
  FaDownload,
} from "react-icons/fa";

export const SlipLightboxModal = ({ isOpen, slipUrl, onClose }) => {
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setScale(1);
      setRotation(0);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !slipUrl) return null;

  const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.25, 3));
  const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.25, 0.5));
  const handleRotate = () => setRotation((prev) => (prev + 90) % 360);
  const handleReset = () => {
    setScale(1);
    setRotation(0);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = slipUrl;
    link.download = `slip_${Date.now()}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-xs p-4 animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="relative bg-slate-950/90 border border-slate-700/60 rounded-md max-w-4xl w-full max-h-[90vh] flex flex-col overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header Toolbar */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-800 bg-slate-900 text-white">
          <h4 className="font-bold text-sm text-slate-200">
            🔎 ตรวจสอบสลิปการโอนเงิน (Slip Viewer)
          </h4>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleZoomIn}
              className="p-2 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs transition-colors"
              title="ขยายภาพ"
            >
              <FaSearchPlus />
            </button>
            <button
              type="button"
              onClick={handleZoomOut}
              className="p-2 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs transition-colors"
              title="ย่อภาพ"
            >
              <FaSearchMinus />
            </button>
            <button
              type="button"
              onClick={handleRotate}
              className="p-2 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs transition-colors"
              title="หมุนภาพ 90 องศา"
            >
              <FaRedo />
            </button>
            <button
              type="button"
              onClick={handleReset}
              className="px-2.5 py-1.5 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs font-semibold transition-colors"
              title="รีเซ็ตขนาด"
            >
              100%
            </button>
            <button
              type="button"
              onClick={handleDownload}
              className="p-2 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs transition-colors"
              title="ดาวน์โหลดรูปสลิป"
            >
              <FaDownload />
            </button>
            <button
              type="button"
              onClick={() => window.open(slipUrl, "_blank")}
              className="p-2 text-slate-300 hover:text-white bg-slate-800 hover:bg-slate-700 rounded-md text-xs transition-colors"
              title="เปิดในแท็บใหม่"
            >
              <FaExternalLinkAlt />
            </button>
            <button
              type="button"
              onClick={onClose}
              className="p-2 text-rose-400 hover:text-rose-300 bg-rose-950/60 hover:bg-rose-900/80 rounded-md text-sm ml-2 transition-colors"
              title="ปิดหน้าต่าง"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        {/* Image Content Area */}
        <div className="flex-1 overflow-auto p-4 flex items-center justify-center min-h-[400px] max-h-[75vh] bg-slate-950">
          <img
            src={slipUrl}
            alt="Transfer Slip"
            style={{
              transform: `scale(${scale}) rotate(${rotation}deg)`,
              transition: "transform 0.15s ease-out",
            }}
            className="max-h-[70vh] w-auto max-w-full object-contain rounded-md shadow-lg select-none"
          />
        </div>
      </div>
    </div>
  );
};
